import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const buddhistYear = currentYear + 543;

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {buddhistYear} ({currentYear}) ระบบบริหารงานนายหน้าประกันภัย
      </Typography>
      <Typography variant="caption" color="text.secondary">
        เวอร์ชัน 1.0.0 | พัฒนาด้วย{' '}
        <Link href="https://reactjs.org/" target="_blank" rel="noopener">
          React
        </Link>{' '}
        และ{' '}
        <Link href="https://mui.com/" target="_blank" rel="noopener">
          Material-UI
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
